/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maintenancedescriptionongoing2Inputs */



/**
* | output |
* | --- |
* | "We are currently conducting maintenance. This may result in limitations in the use of the application and even outages. Thank you for your understanding." |
*
* @param {Maintenancedescriptionongoing2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const maintenancedescriptionongoing2 = /** @type {((inputs?: Maintenancedescriptionongoing2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maintenancedescriptionongoing2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("We are currently conducting maintenance. This may result in limitations in the use of the application and even outages. Thank you for your understanding.")
	return /** @type {LocalizedString} */ ("Wir führen derzeit Wartungsarbeiten durch. Es kann infolgedessen zu Einschränkungen bei der Nutzung der Anwendung und auch zu Ausfällen kommen. Vielen Dank für dein Verständnis.")
});
export { maintenancedescriptionongoing2 as "maintenanceDescriptionOngoing" }